import { gql } from '@src/lib/gql'

/** ADV-B3 / L13 — founder open-seat UserMatches for named-seat directory % */
export const DIRECTORY_FOUNDER_OPEN_SEAT_MATCHES = gql`
  query DirectoryFounderOpenSeatMatches($searchingUserId: String!) {
    scoUserMatches(searchingUserId: $searchingUserId, pageSize: 200, order: [["matchScore", "desc"]]) {
      items {
        id
        userMatchId
        targetUserId
        matchScore
        matchScoreAsPercent
        userSearch {
          id
          userSearchId
          groupRequest {
            id
            groupRequestId
            title
            groupRequestTypeKey
          }
        }
      }
    }
  }
`
